import Util from '@/helper/Utility.js';

export function TniConfigModel(res) {
    this.consent_text_url = res.consent_text_url;
    this.consent_image_url = res.consent_image_url;
    this.success_qr_video_url = res.success_qr_video_url;
    this.error_download_policy_message = res.error_download_policy_message;
    this.consent_standard_register_image_url = res.consent_standard_register_image_url;
    this.consent_standard_register_success_image_url = res.consent_standard_register_success_image_url;
    this.consent_standard_register_error_image_url = res.consent_standard_register_error_image_url;
    this.marketingtemplate_renewal_register_image_url = res.marketingtemplate_renewal_register_image_url;
    this.marketingtemplate_renewal_register_error_image_url = res.marketingtemplate_renewal_register_error_image_url;
    this.new_register_image_url = res.new_register_image_url;
    this.new_register_success_image_url = res.new_register_success_image_url;
    this.new_register_error_image_url = res.new_register_error_image_url;
  
    this.getParams = function () {
        let params = {
            consent_text_url: this.consent_text_url,
            consent_image_url: this.consent_image_url,
            success_qr_video_url: this.success_qr_video_url,
            error_download_policy_message: this.error_download_policy_message,
            consent_standard_register_image_url: this.consent_standard_register_image_url,
            consent_standard_register_success_image_url: this.consent_standard_register_success_image_url,
            consent_standard_register_error_image_url: this.consent_standard_register_error_image_url,
            marketingtemplate_renewal_register_image_url: this.marketingtemplate_renewal_register_image_url,
            marketingtemplate_renewal_register_error_image_url: this.marketingtemplate_renewal_register_error_image_url,
            new_register_image_url: this.new_register_image_url,
            new_register_success_image_url: this.new_register_success_image_url,
            new_register_error_image_url:this.new_register_error_image_url,
        };  
        return Util.cleanObjectEmptyStr(params);
    };
}
 